
import React, { useState } from 'react';
import { withStyles } from '@mui/styles';

import Skeleton from '@mui/material/Skeleton';
import {
    List,
    ListItem,
    ListItemText,
    Paper
} from '@mui/material';
import SyncAltIcon from '@mui/icons-material/SyncAlt';

import { SortableList } from '..';

const style = {
    root: {
        margin: 'auto',
        width: '100%',
    },
    paper: {
        width: '100%',
        height: 340,
        overflow: 'auto',
        border: '1px solid var(--line)',
        borderRadius: 8,
        boxShadow: 'none',
        background: 'var(--surface)',
    },
    icon: {
        alignSelf: 'center',
        color: 'var(--muted-2)',
        flex: 'none',
    },
    main: {
        width: '100%',
    },
    primary: {
        fontSize: '12.5px !important',
        fontFamily: 'inherit !important',
        color: 'var(--ink)',
    },
    item: {
        paddingBottom: '0 !important',
        paddingTop: '0 !important',
        minHeight: 32,
        borderBottom: '1px solid var(--line-2)',
        cursor: 'pointer',
        '&:hover': {
            background: 'var(--surface-2)',
        },
    }
};

const Item = ({classes, value, labelId}) => (
    <ListItemText 
        classes={{
            primary: classes.primary,
        }}
        id={labelId} 
        primary={`${value.label || value.value}`} 
        style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', fontSize: '1em'}} 
    />
)
const ListLeft = ({classes, items, handleToggle}) =>{
    return(
        <Paper className={classes.paper} style={{width: '100%'}}>
            <List dense component="div" role="list">
                {items.map(value => {
                    const labelId = `transfer-list-item-${value.value}-label`;
                    return (
                        <ListItem key={value.value} role="listitem" onClick={handleToggle(value)} classes={{root: classes.item}}>
                            <Item classes={classes} value={value} labelId={labelId}/>
                        </ListItem>
                    )
                })}
                <ListItem />
            </List>
        </Paper>
    )
};

const ListRight = ({classes, items, handleToggle, onSortabe}) =>{
    return(
        <Paper className={classes.paper} style={{width: '100%'}}>
            <SortableList 
                items={items}
                itemsFields={ [{value: 'label'}]}
                useDragHandle={true} 
                setActiveNode={handleToggle} 
                sortable={true}
                onSortabe={onSortabe}
                handleElementClick={handleToggle}
            />
            {/* <List dense component="div" role="list">
                {items.map(value => {
                    const labelId = `transfer-list-item-${value.value}-label`;
                        return (
                            <ListItem key={value.value} role="listitem" onClick={handleToggle(value)} classes={{root: classes.item}}>
                              <Item classes={classes} value={value} labelId={labelId}/>
                            </ListItem>
                        )
                })}
                <ListItem />
            </List> */}
        </Paper>
    )
};

const TrasferSortableInput = ({classes, input, avalible, ...props}) => {
    const [left, setLeft] = useState((avalible || []).filter((el) => !(input.value || []).find((r) => r.value === el.value)));
    const [right, setRight] = useState(input.value || []);

    const not = (a, b) => {
        return a.filter(value => b.value!==value.value);
    }

    const onSortabe = (newData) => {
        input.onChange(newData);
    }

    const handleToggleLeft = value => () => {
        const leftIndex = left.find( l => l.value===value.value);
        let newRight = [];
        let newLeft = [];
        if(leftIndex){
            newRight = right.concat([value]);
            newLeft = not(left, value);
        }else{
            newLeft = left.concat([value]);
            newRight = not(right, value);
        }
        input.onChange(newRight);
        setLeft(newLeft);
        setRight(newRight);
        return;
    };
    const handleToggleRight = (index) => {
        const value = right[index];
        const leftIndex = left.find( l => l.value===value.value);
        let newRight = [];
        let newLeft = [];
        if(leftIndex){
            newRight = right.concat([value]);
            newLeft = not(left, value);
        }else{
            newLeft = left.concat([value]);
            newRight = not(right, value);
        }
        input.onChange(newRight);
        setLeft(newLeft);
        setRight(newRight);
        return;
    };

    return(
        <div className={`pc-transfer ${classes.main}`}>
            {(left && right) ?
                <div className="pc-transfer-cols">
                    <div className="pc-field" style={{ flex: 1, minWidth: 0 }}>
                        <label className="pc-field__label">Доступные</label>
                        <ListLeft items={left} classes={classes} handleToggle={handleToggleLeft}/>
                    </div>
                    <SyncAltIcon className={classes.icon}/>
                    <div className="pc-field" style={{ flex: 1, minWidth: 0 }}>
                        <label className="pc-field__label">Выбранные</label>
                        <ListRight items={right} fields={avalible} classes={classes} handleToggle={handleToggleRight} onSortabe={onSortabe}/>
                    </div>
                </div>
            : 
                <div style={{display: 'flex'}}>
                    <div style={{padding: '16px 0px 0px 0px', width: '100%'}}>
                        <Skeleton variant="text" />
                        <Skeleton variant="rect" height={242} style={{padding: '0 20px'}}/>
                    </div>
                    <SyncAltIcon className={classes.icon}/>
                    <div style={{padding: '16px 0px 0px 0px', width: '100%'}}>
                        <Skeleton variant="text" />
                        <Skeleton variant="rect" height={242} style={{padding: '0 20px'}}/>
                    </div>
                </div>
            }
        </div>
    )
}

export default withStyles(style)(TrasferSortableInput);